// Unified "Aide" support widget (2026-07-08). One labeled pill — WhatsApp
// glyph + "Aide" — that opens the same pre-filled WhatsApp chat the old
// scattered buttons did. Mounted on the customer NON-editor surfaces (upload
// flow, magic upload, flipbook preview); the editor deliberately has none
// (its floating toolbars own the bottom of the screen — Yahya's rule).
//
// Positioning contract: bottom-LEFT, z-40 — always UNDER sheets, popups and
// floating toolbars (z-50+), and clear of the zoom pill / primary CTAs that
// live bottom-right. Pages with a fixed bottom bar lift it via bottomOffset.
// The storefront twin lives in shopify-theme/snippets/help-widget.liquid —
// keep the look in sync when touching either.
//
// Phone:   +212 620 066 907
// Message: "Bonjour, j'ai besoin d'aide pour mon album Storiz."

const SUPPORT_PHONE_E164 = '212620066907'; // wa.me format strips the '+'
const SUPPORT_MESSAGE = "Bonjour, j'ai besoin d'aide pour mon album Storiz.";

export function HelpFAB({ bottomOffset = 16 }: { bottomOffset?: number }) {
  // PARKED (2026-07-11): the unified Aide pill is approved-in-plan but its
  // result hasn't been shown to Yahya yet and the storefront twin isn't built,
  // so it must NOT ship on the force-print deploy. Returning null keeps every
  // mount a harmless no-op; flip this back to render when finishing the widget.
  return null;
  // eslint-disable-next-line no-unreachable
  const href = `https://wa.me/${SUPPORT_PHONE_E164}?text=${encodeURIComponent(SUPPORT_MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Aide — ouvrir une discussion WhatsApp"
      title="Aide"
      className="fixed left-4 z-40 flex items-center gap-2 rounded-full pl-2.5 pr-3.5 h-11 transition-transform active:scale-95 hover:scale-[1.03]"
      style={{
        bottom: `calc(${bottomOffset}px + env(safe-area-inset-bottom, 0px))`,
        background: '#FFFFFF',
        border: '1px solid rgba(201,162,74,0.35)',
        boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
        textDecoration: 'none',
      }}
    >
      {/* Official WhatsApp glyph — kept per Yahya (customers recognize it). */}
      <span
        className="w-7 h-7 rounded-full flex items-center justify-center shrink-0"
        style={{ background: '#25D366', color: '#fff' }}
        aria-hidden="true"
      >
        <svg width={16} height={16} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
          <path d="M16.001 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.55-1.71a12.74 12.74 0 0 0 6.25 1.62h.001c7.06 0 12.799-5.73 12.799-12.8 0-3.42-1.33-6.63-3.75-9.05A12.72 12.72 0 0 0 16.001 3.2zm0 23.31h-.001a10.5 10.5 0 0 1-5.36-1.47l-.38-.23-3.89 1.02 1.04-3.79-.25-.39a10.55 10.55 0 0 1-1.62-5.65c0-5.84 4.75-10.59 10.6-10.59 2.83 0 5.49 1.1 7.49 3.1a10.53 10.53 0 0 1 3.1 7.5c0 5.84-4.75 10.5-10.71 10.5zm5.83-7.91c-.32-.16-1.88-.93-2.17-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.88-1.77-2.2-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.72-1.73-.99-2.37-.26-.62-.53-.53-.72-.54-.18-.01-.4-.01-.61-.01-.21 0-.55.08-.84.4-.29.32-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.22 3.39 5.39 4.76.75.32 1.34.52 1.8.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.26-.74.26-1.37.18-1.51-.08-.13-.29-.21-.61-.37z" />
        </svg>
      </span>
      <span className="text-sm font-semibold" style={{ color: '#1F2937' }}>Aide</span>
    </a>
  );
}
